module.exports = __webpack_public_path__ + "11de1296bdd6ea2f40d3e712c5eec0d2.svg";